const locale = {
  NAV: {
    HOME: "الرئيسية",
    APPLY: "التقديم",
    HOW_IT_WORKS: "كيف تعمل؟",
    ABOUT: "حول",
    FINANCIAL_PRODUCT: "المنتج المالي",
    CONTACT: "اتصل بنا",
    FAQS: "الأسئلة الشائعة",
  },
  SIGN_IN: {
    LOGIN: "تسجيل الدخول",
    TITLE: "تسجيل الدخول",
    DESCRIPTION: "أكثر من تمويل",
    FIELDS: {
      ID: "الهوية الوطنية / الإقامة",
      PASSWORD: "كلمة السر",
    },
    FORGOT_PASSWORD: "هل نسيت كلمة السر؟",
    DONT_HAVE_AN_ACCOUNT: "ليس لديك حساب؟",
    SIGN_UP: "أفتح حساب الأن",
    ID_10_DIGITS: "يجب أن يتكون رقم الهوية من 10 أرقام بالضبط.",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا.",
    CREDENTIAL_SUCCESS: "تم التحقق من البيانات بنجاح",
    SOMETHING_WENT_WRONG: "حدث خطأ ما",
    TIMEOUT: "انتهت المهلة. يرجى تسجيل الدخول مرة أخرى",
    VERIFICATION_COMPLETE: "اكتمل التحقق",
    WRONG_OTP: "رمز التحقق غير صحيح!",
    SEND: "إرسال",
    RESEND_CODE: "إعادة إرسال الرمز",
    WE_HAVE_SENT: "لقد أرسلنا كلمة المرور المؤقتة (OTP) عبر الرسائل القصيرة",
    HELP_LINE_CALL: "للمساعدة يرجي الاتصال بهذا الرقم: ٩٢٠٠٠٥٤٧٧",
    OR: "أو",
    HELP_LINE_EMAIL: "ارسل بريد إلكتروني إلى: info@tamweel-aloula.com",
    INVALID_CREDENTIALS: "بيانات الاعتماد غير صحيحة (المعرف أو كلمة المرور).",
    ACCOUNT_DELETED: "تم حذف الحساب.",
    DEVICE_REGISTRATION_LIMIT_REACHED:
      "تم الوصول إلى الحد الأقصى لتسجيل الأجهزة.",
    IVR_NOT_VERIFIED: "لم يتم التحقق من الجهاز عن طريق المكالمة.",
    DEVICE_NOT_REGISTERED: "هذا الجهاز غير مسجل.",
    LOGIN_FAILED: "حدث خطأ غير متوقع، يرجى المحاولة مرة أخرى لاحقاً.",
    HELP_AND_SUPPORT: 'المساعدة والدعم'
  },
  SIGN_UP: {
    TITLE: "التسجيل",
    DESCRIPTION: "خطوة أقرب إلى الحلول المالية",
    FORM_DESCRIPTION: "من فضلك املأ النموذج التالي",
    HELP_LINE:
      "للمساعدة يرجي الاتصال بهذا الرقم: ٩٢٠٠٠٥٤٧٧ او ارسال ايميل الي : info@tamweel-aloula.com",
    DONE: "موافق",
    LABELS: {
      ID: "الهوية الوطنية / الإقامة",
      PHONE: "رقم الهاتف المسجل في أبشر",
      EMAIL: "بريد إلكتروني",
      CONFIRM_EMAIL: "تأكيد عنوان البريد الإلكتروني",
      PASSWORD: "كلمة المرور",
      CONFIRM_PASSWORD: "تأكيد كلمة المرور",
    },
    FIELDS: {
      ID: "الهوية",
      PHONE: "9665XXXXXXXX",
      EMAIL: "بريد إلكتروني",
      CONFIRM_EMAIL: "تأكيد عنوان البريد الإلكتروني",
      PASSWORD: "كلمة المرور",
      CONFIRM_PASSWORD: "تأكيد كلمة المرور",
      HIJRI_DATE: "تاريخ الميلاد بالهجرى",
      GEORGIAN_DATE: "تاريخ الميلاد بالميلادى",
      SELECT_DATE_TYPE: "أختر نوع التاريخ",
    },
    TERMS_AGREE: "لقد قرأت ووافقت على",
    TERMS_MODEL: {
      TITLE: "الشروط والأحكام",
      CONTENT: `
    أقر أنا العميل مقدم الطلب و أنا بكامل الأهلية الشرعية بالإطلاع و الموافقة على شروط تقديم الخدمة أدناه, و اعتبار هذه الشروط جزءاً لا يتجزأ من طلب الخدمة بموجب موافقتي وهي ما يُفسر بتوقيع ملزم نافي الجهالة. أقر أنا مقدم طلب الخدمة بتقديم كافة البيانات والمعلومات والوثائق الصحيحة من خلال هذه الخدمة وأتحمل كافة ما يترتب عنها. 1. المستخدم: يعني العميل أو الشخص المفوض من العميل و المصرح له من قبل الشركة بالدخول لتقديم البيانات والمستندات على طلب المنتج. 2. تلتزم الشركة بتنفيذ كافة التعليمات والمعاملات الواردة من المُستخدم إلكترونياً بشرط أن تكون متوافقة مع نظام العمل في الشركة و تعليمات الجهات الرسمية المختصة والقوانين التمويلية وفقا لتقديرها المطلق. 3.هذه الخدمة تتم إلكترونياً باستخدام التصديق الرقمي ولا يجوز الطعن بتنفيذها إلكترونياً. 4 يحق للشركة تقييد أي عمليات ينفذها المُستخدم إلكترونيا على العقد ويلتزم العميل بدفع الرسوم التي تحددها الشركة مقابل الاستفادة من هذه الخدمة ، والتي قد يتم تعديلها من وقت لآخر وفقا لتقديرها المطلق. 5. أقر أنا مقدم الطلب عن المسؤولية الإلكترونية ، والمسؤولية الكاملة عن الشخص المفوض من قبلي لاستخدام الخدمات الإلكترونية وإجراء المعاملات الكاملة من خلال المستخدم والرقم السري وكل مايتعلق ومقتضيات المحافظة عليهما ، وعدم الإفصاح عن الرقم لأي جهة حتى موظف الشركة أو أي شخص آخر أو جهة أخرى. 6. أقر أنا مقدم الطلب بأن الشركة والجهات التابعة لها وموظفي الشركة غير مسؤولين عن أي خسائر أو أضرار أو مطالبة مالية أو خلافها ناتجة عن استعمال حساب المستخدم و الرقم السري الخاص بي ، وألتزم بإخطار الشركة فور حدوث ما يخالف ذلك بموجب خطاب موثق مني بالحادثة إذا تبين لي أن الرقم السري قد أصبح معلوما للآخرين حتى تتمكن الشركة من إجراء اللازم ، وأكون مسئولا عن جميع المعاملات والتعليمات الصادرة من حساب المستخدم لحين تسلم الشركة للبلاغ الخطي والحصول على إفادة خطية منها بذلك. 7. أقر أنا مقدم الطلب بالمحافظة الكاملة على سرية حساب المستخدم معلوماته ومعاملاته التمويلية ، وأكون مسئولا عن أي استعمال أو استخدام غير مرخص به ووتحمل كافة النتائج التي قد تترتب على ذلك سواء كانت مباشرة أو غير مباشرة. 8. أٌقر أنا مقدم الطلب بعدم ملكية الحقوق الفكرية لبرامج ومستندات الخدمات الإلكترونية المقدمة و أوافق على عدم السماح لي كمستخدم بنسخ أو تعديل البرامج أو خلافه أو تحميل أو نقل برامج الخدمات الإلكترونية إلى موقع إلكتروني مماثل. 9. أقر أنا مقدم الطلب بإمكانية الاطلاع على حالة الطلب ومعرفة الحالة (قبول أو رفض) من خلال هذه الخدمة.كما أقر بأن ليس على الشركة أي إلتزامات عند عدم قبول الطلب لإي سبب من الأسباب. 10. يحق للشركة إلغاء الخدمة المطلوبة في أي وقت دون إشعار مُسبق إذا تبين عدم صحة المعلومات أو المستندات المقدمة أو عدم توافقها مع الشروط والأحكام الداخلية للشركة أو الخارجية للجهات ذات العلاقة. 11. أقر بالموافقة على تلقي كافة المراسلات و الإشعارات المتعلقة بالطلب المقدم من قبلي عن طريق البريد الإلكتروني والرسائل النصية والاتصال والالتزام باتخاذ كافة الاحتياطات اللازمة لسرية المراسلات ، وأكون مسؤول عن أي انتهاكات قد تنجم عن ذلك. 12. أقر بالموافقة على أحقية الشركة بتسجيل كافة الاتصالات والتعليمات الوارد عن طريق الخدمات الإلكترونية وأن تكون هذه التسجيلات الصوتية بينة على ما ورد فيها من معلومات في حال استخدام الرقم المجاني أو قسم خدمات العملاء. 13. أوافق على تزويد تمويل الأولى بأي معلومات أو بيانات تطلبها مني لتأسيس حسابي لدى الشركة أو لمراجعة أو للإدارة و أفوض الشركة بأن تحصل على مايلزم أو تحتاج إليه من معلومات تخصني أو تخص حسابي المذكور أو أي حساب آخر يكون لدى الشركة, من الشركة السعودية للمعلومات الائتمانية (سمة). كما أوافق على أن تفصح الشركة عن المعلومات الخاصة بي بحسابي المذكور أو أي حساب آخر يكون المفوض للشركة السعودية للمعلومات الائتمانية (سمة) من خلال اتفاقية مشاركة المعلومات أو لأي جهة أخرى يوافق عليها البنك المركزي(ساما). كما أقر بمشروعية مصادر الدخل المستخدمة في التعامل مع تمويل الأولى. 14. أقر أنا مقدم الطلب بأن أي تأخير ناجم من الشركة بالمطالبة عن أي حق أو صلاحية واردة لها في هذه الشروط لا يعد تنازلا عن هذا الحق أو الصلاحية ومن حق الشركة المُطالبة به في أي وقت تشاء. 15. أقر أنا مقدم الطلب بأن تحتفظ الشركة بحقها في تعديل هذه الشروط ، ويُعد الإستمرار في استعمال المستخدم من قبلي موافقة مني بذلك على التعديل. 16. يتم تنفيذ وتفسير هذه الشروط طبقاً لأحكام القوانين والأنظمة المعمول بها في المملكة العربية السعودية ، وكل ما لم يرد به نص يكون طبقاً للأنظمة السعودية ويتم حسم النزاعات المُتعلقة بهذه الخدمة أمام المحاكم السعودية المختصة. 17. كما يقر العميل " مقدم الطلب" خلال فترة تقديمه لطلب التمويل لدى شركة تمويل الأولى ولغاية حصوله على ذلك بعدم التقدم لدى أي جهة أخرى للحصول على تمويل أو أي التزام مالي مما قد يؤثر على سجله الائتماني ، كما يقر و يتعهد بالتزامه بالأنظمة والضوابط وتعليمات البنك المركزي السعودي وجميع الضوابط التشريعية الأخرى ، وفي حالة مخالفة ذلك فإنه يحق لشركة تمويل الأولى رفض منحه التمويل المطلوب ومقاضاة العميل " مقدم الطلب" لدى أي جهة رسمية ومطالبته بأي مبالغ أو رسوم أو تعويضات قد نتجت عن تقديمه لهذا الطلب . 18. كما يقر ويتعهد العميل بتحمله كامل المسؤولية عن تقديمه طلب التمويل لدى شركة تمويل الأولى و بعد الحصول على الموافقة الائتمانية عند تقديم طلب التمويل و الموافقة عليه بالمنح لمنتج التمويل المقدم من قبله , كما يقر بمعرفته التامة لعواقب وتبعات تجاوز نسبة عبء الدين المسموح بها نظاما خلال فترة سريان عقد التمويل وعن كل ما ينجم عن مثل هذا التجاوز وإقراره أنه في حالة وقوعه لدى العميل وذلك من خلال تقدمه بطلبات تمويل لدى جهات تمويلية أخرى وحصوله تزامناً أو في أي وقت لاحق على قروض إضافية تزيد من اجمالي التزاماته عن الحد المسموح فإنه يتحمل كامل المسؤولية عن ما تقدم به ويعتبر إخلالا بالشروط التعاقدية مع شركة تمويل وبذلك يتحمل سداد كامل المبلغ المتفق عليه بالعقد، وتحتفظ الشركة بحقها بالمطالبة الفورية والسداد لكامل المبلغ
    `,
      ACTION: "اوافق",
      ACCEPTED: "قبلت",
    },
    NATIONAL_INFORMATION_ACCEPTENCE:
      "السماح لشركة لتمويل الاولى باستخدام خدمات مركز المعلومات للتحقق من الهوية",
    NEWS_AND_OFFERS_CONSENT:
      "أود معرفة أحدث العروض والمستجدات المخصصة من تمويل الأولى",
    ALREADY_ACCOUNT: "هل لديك حساب؟",
    SIGN_IN: "تسجيل الدخول",
    FROM_BUTTON: "متابعة",
    PRIVACY: {
      TITLE: "إشعار الخصوصية",
    },
  },
  HOME: {
    LAST_LOGIN: "آخر تسجيل دخول",
    CREATE_NEW: "إنشاء طلب جديد",
    REQUEST: "الطلبات المقدمة",
    APPL_NO: "الرقم المرجعي",
    PRODUCT: "المنتج",
    CONTRACT: "العقد",
    STATUS: "الحالة",
    VIEW: "عرض التطبيق",
    COMPLETE: "الطلب كامل",
    SEARCH: "ابحث عن الاسم والمبلغ وما إلى ذلك.",
    ARE_YOU_SURE: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
    EMPLOYMENT_DETAILS: "تفاصيل الوظيفة",
    Hi: "هلا",
    DIGITAL_APP_ID: "رقم التطبيق",
    CONTRACT_SIGNING: "توقيع العقد",
    VIEW_CONTRACT: "اظهار العقد",
    UPLOAD_DOCUMENT: "رفع مستند",
    APPLICATION_TIME_LINE: "خط الزمن للتطبيق",
    VIEW_OFFER: "إظهار العرض",
    NO_REQUESTS: "لا يوجد تطبيقات بعد",
    EXPLORE_SERVICES: "استكشف خدماتنا وقدم طلبك:",
  },
  CREATE_REQUEST: {
    OF: "من",
    STEPS: "خطوات",
    AUTO: "قرض السيارة",
    CANCEL: "إلغاء",
    CANCEL_REQUEST: "إلغاء الطلب؟",
    CONFIRM: "تأكيد",
    ARE_YOU_SURE_REQUEST: "هل أنت متأكد أنك تريد إلغاء الطلب؟",
    DOCUMENT: "وثيقة",
    CLICK_TO_UPLOAD: "انقر لتحميل الملف",
    EMPLOYMENT_DETAILS: "تفاصيل العمل",
    FINANCIAL_DETAILS: "التفاصيل المالية",
    NEXT: "التالي",
    SALES_REFERENCE: "مرجع المبيعات",
    DO_YOU_SALE_REFERENCE: "هل لديك مرجع مندوب المبيعات؟",
    EXACTLY_8_ALLOWED: "يُسمح بـ 8 أرقام فقط.",
    SALES_PERSON_REF: "مرجع مندوب المبيعات",
    LOAN_DETAILS: "تفاصيل التمويل",
    PERSONAL_DETAILS: "التفاصيل الشخصية",
    GREAT: "رائع!",
    YOUR_REQUEST: "تم إرسال طلبك",
    SUBMITTED_FOR_REVIEW: "للمراجعة.",
    THANKS_FOR_APPLYING: "شكرًا لتقديمك الطلب.",
    APP_NO: "رقم الطلب",
    FEEDBACK: "ساعدنا على التحسين وقيم تجربتك معنا!",
    THANKS_FOR_FEEDBACK: "شكرًا لملاحظاتك",
    WRITE_COMMENT: "اكتب تعليقك",
    ADD_COMMENT: "إضافة تعليق",
    COMMENT_SUB: "لا تتردد في إخبارنا عن تجربتك",
    ONLY_ONE_MINUTE: 'سيستغرق هذا دقيقة واحدة فقط',
    DONE: "تم",
    WE_WILL_GET_BACK: "سنتواصل معك قريبًا.",
    KINDLY_MESSAGE: "يرجى الاتصال بفريق المبيعات.",
    FURTHER_ASSISTANCE: "920005477 للحصول على المساعدة.",
    Full_Name: "الاسم الكامل",
    // Address: "العنوان",
    Street_Name: "اسم الشارع",
    Building_Num: "رقم المبنى",
    Additional_Num: "الرقم الإضافي",
    District_Name: "اسم الحي",
    Post_Code: "الرمز البريدي",
    ID_Expiry_Date: "تاريخ انتهاء الهوية",
    street_name_required: "اسم الشارع مطلوب",
    buildingnum_required: "رقم المبنى مطلوب",
    additional_name_required: "الرقم الإضافي مطلوب",
    District_name_required: "اسم الحي مطلوب",
    Post_code_required: "الرمز البريدي مطلوب",
    Post_code_only_number: "يجب أن يكون الرمز البريدي رقمًا",
    building_num_only_number: "يجب أن يكون رقم المبنى رقمًا",
    Post_code_six_digits: "يجب ألا يتجاوز الرمز البريدي 6 أرقام",
    Post_code_six_digits_min: "لا يمكن أن يكون الرمز البريدي أقل من 6 أرقام",
    ID: "الهوية",
    Region: "المنطقة",
    City: "المدينة",
    Marital_status: "الحالة الاجتماعية",
    Title: "اللقب",
    Number_of_dependents: "عدد المعالين",
    Nationality: "الجنسية",
    IBAN: "رقم الحساب البنكي الدولي (IBAN)",
    Gender: "الجنس",
    Employment_type: "نوع العمل",
    Education_Level: "المستوى التعليمي",
    Resident_Status: "حالة الإقامة",
    Employment_Sector: "قطاع العمل",
    Joining_Date: "تاريخ الانضمام",
    PEP_Relation:
      "هل أنت شخص معرف سياسياً، أو لديك علاقة مع شخص معرف سياسياً (PEP)?",
    Real_Benificiary: "هل أنت المستفيد الحقيقي من التمويل؟",
    Real_Benificiary_Name: "اسم المستفيد الحقيقي",
    Related_Party:
      "هل تربطك صله قرابه من الدرجة الأولى مع احد أعضاء مجلس الإدارة, او أعضاء اللجان او كبار المدراء التنفيذين ؟",
    Party_Postion: "المنصب",
    pep_relation_required: "هذا الحقل مطلوب",
    real_benificiary_required: "هذا الحقل مطلوب",
    related_party_required: "هذا الحقل مطلوب",
    party_position_required: "هذا الحقل مطلوب",
    Type_of_loan: "نوع التمويل",
    Facility: "المرفق",
    Requested_loan_amount: "المبلغ المطلوب للقرض",
    SalesRef: "الرقم المرجعي للمبيعات (اختياري)",
    Tenure: "مدة القرض (بالأشهر)",
    Food_expenses: "نفقات الطعام",
    Housing_expenses: "نفقات السكن",
    Domestic_workers: "العمالة المنزلية",
    Education_expenses: "نفقات التعليم",
    Health_care_expenses: "نفقات الرعاية الصحية",
    Communication_and_transportation_expenses: "نفقات الاتصالات والنقل",
    Insurance_expenses: "نفقات التأمين",
    Any_expected_future_expenses: "أي نفقات مستقبلية متوقعة",
    Total_expenses: "إجمالي النفقات",
    Asset_manufacturer: "الشركة المصنعة للأصل",
    Asset_model: "نموذج الأصل",
    Asset_model_type: "نوع نموذج الأصل",
    Asset_color: "لون الأصل",
    Asset_condition: "حالة الأصل",
    Asset_price: "سعر الأصل",
    Asset_model_year: "سنة نموذج الأصل",
    Down_payment: "الدفعة المقدمة",
    Ballon_payment: "الدفعة الاخيرة",
    Dealer_name: "اسم التاجر",
    Document: "وثيقة",
    First_name: "الاسم الأول",
    Middle_name: "الاسم الأوسط",
    Family_name: "اسم العائلة",
    ID_type: "نوع الهوية",
    ID_number: "رقم الهوية",
    Phone: "الهاتف",
    Email: "البريد الإلكتروني",
    Select_Marital: "اختر حالتك الاجتماعية.",
    Pick_Dependents: "اختر عدد المعالين.",
    Only_Arabic: "فقط الأحرف العربية مسموح بها",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا.",
    MAX_12_MONTHS: "يجب أن يكون أقل من أو يساوي 12 شهرًا",
    MAX_36_MONTHS: "يجب أن يكون أقل من أو يساوي 36 شهرًا",
    MAX_60_MONTHS: "يجب أن يكون أقل من أو يساوي 60 شهرًا",
    IBAN_22: "يجب أن يتكون رقم الآيبان من 22 رقمًا.",
    IBAN_ONLY_NUMBERS: "يجب أن يحتوي رقم الآيبان على أرقام فقط.",
    MUST_BE_INTEGER: "يجب أن يكون عدد صحيح.",
    MUST_BE_ATLEAST: "يجب أن يكون على الأقل 25,000",
    MUST_BE_ATLEAST_3000: "يجب أن يكون على الأقل 3000",
    MUST_BE_ATLEAST_2500: "يجب أن يكون على الأقل 2500",
    MUST_BE_ATLEAST_2000: "يجب أن يكون على الأقل 2000",
    MUST_BE_8_DIGITS: "يجب أن يحتوي على 8 أرقام.",
    CANNOT_EXCEED: "لا يمكن أن يتجاوز 7 أرقام",
    CANNOT_EXCEED_500000: "لا يمكن أن يتجاوز 500000",
    CANNOT_EXCEED_50000: "لا يمكن أن يتجاوز 50000",
    CANNOT_EXCEED_4: "لا يمكن أن يتجاوز 4 أرقام",
    MUST_BE_ATLEAST_0: "يجب أن يكون على الأقل 0",
    CANNOT_EXCEED_7: "لا يمكن أن يتجاوز 7 أرقام",
    DOWN_PAYMENT_20:
      "يجب أن تكون الدفعة الأولى 3 آلاف أو أكثر ويجب أن تكون أقل من سعر الأصول",
    BALLON_PAYMENT_40: "يجب ألا تتجاوز دفعة البالون 40% من سعر الأصل",
    BALLON_REQUIRED: "دفعة البالون مطلوبة",
    DOWN_PAYMENT_REQUIRED: "مطلوب دفعة مقدمة",
    NAME_REQUIRED: "الاسم مطلوب.",
    PHONE_REQUIRED: "رقم الهاتف مطلوب.",
    LOADING_DETAILS: "تحميل التفاصيل الشخصية...",
    LOADING_ADDRESS_DETAILS: "جارٍ تحميل تفاصيل العنوان...",
    LOADING_MARITAL_DETAILS: "تحميل التفاصيل الزوجية...",
    LOADING_EMPLOYMENT_DETAILS: "جاري تحميل تفاصيل التوظيف...",
    LOADING_LOAN_DETAILS: "جاري تحميل تفاصيل التمويل...",
    LOADING_FINANCIAL_DETAILS: "جاري تحميل التفاصيل المالية...",
    LOADING_AUTOLOAN_DETAILS: "جاري تحميل تفاصيل قرض السيارة...",
    LOADING_DOCUMENT_DETAILS: "جاري تحميل تفاصيل المستند...",
    LOADING_ASSET_DETAILS: "تحميل تفاصيل الاصول",
    Male: "ذكر",
    Female: "أنثى",
    undefined: "",
    DOC_CONDITION_1: "يرجى ارفاق شهادة التعريف بالراتب",
    DOC_CONDITION_2: "يرجى ارفاق كشف الحساب لأخر ٣ شهور",
    DOC_CONDITION_3: "إذا كان مبلغ التمويل ٤٠،٠٠٠ ريال او أكثر.",
    MAX_FILES_UPLOADED: "تم تحميل الحد الأقصى لعدد الملفات",
    Occupation: "المسمى الوظيفي",
    LOAN_REASON: "سبب التقديم على الطلب",
    LOAN_REASON_REQUIRED: "سبب التقديم على الطلب مطلوب",
  },
  FORGOT_PASSWORD: {
    "Reset password": "اعادة ادخال كلمة المرور",
    "Forgot password?": "نسيت كلمة المرور؟",
    "Please, enter your phone": "فضلا، ادخل رقم الهاتف",
    Send: "ارسال",
    "Return to sign in": "الرجوع الي صفحة المرور",
    "Cannot be empty": "يجب ادخال رقم الهاتف",
    "Must be exactly 9 digits": "رقم الهاتف يحتوي علي ٩ ارقام",
    FORGOT_PASSWORD_LABEL: "رقم الهاتف المسجل في أبشر",
    ONE_TIME_OTP: "لقد أرسلنا كلمة المرور لمرة واحدة (OTP) عبر الرسائل النصية",
    ONE_TIME_PASS: "يرجى إدخال كلمة المرور الجديدة",
    RESET: "إعادة تعيين",
    PASSWORD: "كلمة المرور",
    CONFIRM_PASSWORD: "تأكيد كلمة المرور",
  },
  Marital_status: "الحالة الاجتماعية",
  Region: "المنطقة",
  Title: "اللقب",
  Nationality: "الجنسية",
  Number_of_dependents: "عدد المعالين",
  Male: "ذكر",
  Female: "أنثى",
  City: "مدينة",
  Employment_type: "نوع الوظيفة",
  Education_Level: "مستوى التعليم",
  Resident_Status: "حالة الإقامة",
  Occupation: "المسمى الوظيفي",
  Joining_Date: "تاريخ الانضمام",
  "Select date": "حدد تاريخ",
  "No Data": "لايوجد بيانات",
  "For Private Sector": "للقطاع الخاص",
  APPLICATION_ALREADY_EXISTS: "لديك تطبيق موجود بالفعل",
  APPLICATION_ALREADY_SUBMITTED: "تم تقديم طلبك بالفعل",
  OFFER_PENDING_GENERATION: "العرض قيد الإعداد",
  CONTRACT_PENDING_GENERATION: "العقد قيد الإعداد",
  "Something went wrong": "هناك خطأ ما",
  PRODUCT_NAME: "أسم المنتج",
  ACTIONS: "الإجراءات",
  DELETE: "حذف",
  REFRESH: "اعاده تجميل",
  VIEW_CONTRACT: "شاهد العقد",
  USER_ALREADY_EXISTS: "لديك حساب بالفعل، يرجى تسجيل الدخول",
  DEVICE_ALREADY_REGISTERED: "هذا الجهاز مسجل لدينا باسم عميل مختلف",
  OFFER: {
    Offering: "عرض",
    Product: "منتج",
    KASTLENO: "رقم التطبيق",
    CUSTOMERNAME: "اسم العميل",
    ERRORLOADING: "خطأ في تحميل العرض",
    NO_DATA_ALLOWED_ERR: "لم يتم العثور على بيانات لهذا القسم.",
  },
  OFFER_TABLE: {
    APP_NO: "رقم الطلب",
    PRODUCT_NAME: "اسم المنتج",
    CONTRACT: "العقد",
    STATUS: "الحالة",
    OFFER: "عرض",
    REFRESH: "تحديث",
    DELETE: "حذف",
    VIEW_CONTRACT: "عرض العقد",
    EDIT: "تعديل",

    CONFIRM: "تأكيد؟",
    CONFIRM_BTN: "تأكيد",
    CANCEL: "إلغاء؟",
    CANCEL_BTN: "إلغاء",
    CONFIRM_ACCEPTANCE: "تأكيد قبول العقد؟",
    CONFIRM_REJECTION: "تأكيد رفض العقد؟",
    ACCEPT: "قبول",
  },
  CONTRACT: {
    CONTRACT: "العقد",
    CONTRACT_ACCEPT: "تم قبول العقد",
    CONTRACT_REJECT: "تم رفض العقد",
    CONTRACT_ACCEPTANCE: "هل تؤكد قبول العقد؟",
    CONTRACT_ERROR: "تعذر قبول العقد، يرجى المحاولة مرة أخرى",
    CONTRACT_ERROR_REJECT: "تعذر رفض العقد، يرجى المحاولة مرة أخرى",
    CONFIRM: "تأكيد",
    CONFIRM_QUESTION: "تأكيد؟",
    REJECT_QUESTION: "رفض العقد؟",
    CONFIRM_REJECTANCE: "هل تؤكد رفض العقد؟",
    REJECT: "رفض",
  },
  REQUEST_DETAILS: {
    DETAILS: "تفاصيل الطلب",
    REQUEST_NUMBER: "رقم الطلب",
    CUSTOMERNAME: "الاسم الكامل",
    EMAIL: "البريد الإلكتروني",
    IDNUMBER: "رقم الإقامة",
    DATE_OF_EXPIRY: "تاريخ الانتهاء",
    IBAN: "رقم الحساب البنكي",
    GENDER: "الجنس",
    MOBILE: "رقم الجوال",
    FOOD_EXPENSES: "نفقات الطعام",
    HOUSING_EXPENSES: "نفقات السكن",
    DOMESTIC_WORKERS: "العاملين المنزليين",
    EDUCATION_EXPENSES: "نفقات التعليم",
    HEALTHCARE_EXPENSES: "نفقات الرعاية الصحية",
    COMM_TRANS_EXPENSES: "نفقات الاتصالات والنقل",
    INSURANCE_EXPENSES: "نفقات التأمين",
    FUTURE_EXPENSES: "أية نفقات مستقبلية متوقعة",
    EMPCATID: "نوع التوظيف",
    SECTORID: "قطاع التوظيف",
    DATEOFJOINING: "تاريخ الانضمام",
    QUALIFICATIONID: "المستوى التعليمي",
    RESIDENTID: "حالة الإقامة",
    PRODUCTID: "نوع التمويل",
    SUBPRODUCTID: "المنشأة",
    REQUESTED_AMOUNT: "المبلغ المطلوب",
    TENURE: "المدة (بالأشهر)",
    ASSET_MANUFACTURER: "الشركة المصنعة للأصل",
    ASSET_MODEL: "نموذج الأصل",
    ASSET_MODEL_TYPE: "نوع نموذج الأصل",
    COLORID: "لون الأصل",
    ASSET_CONDITION: "حالة الأصل",
    ASSET_PRICE: "سعر الأصل",
    ASSET_MODEL_YEAR: "سنة نموذج الأصل",
    DOWN_PAYMENT: "الدفعة المقدمة",
    BALLOON_PAYMENT: "الدفعة الاخيرة",
    DEALERID: "اسم التاجر",
  },
  VIEW_OFFER: {
    FINANCE_AMOUNT: "مبلغ التمويل",
    DOWN_PAYMENT: "الدفعة المقدمة",
    BALLOON_PAYMENT: "الدفعة الاخيرة",
    EMI: "الأقساط الشهرية",
    AGREEMENT_TOTAL: "إجمالي التمويل",
    TENURE: "مدة العقد",
    NO_DATA_FOUND: "لم يتم العثور على بيانات لهذا الجزء.",
    APR: "معدل الفائدة السنوي",
  },
  LOADING: "تحميل ...",
  SETTINGS: {
    USER_PROFILE: "ملف تعريفي للمستخدم",
    Full_Name: "الاسم الكامل",
    Address: "العنوان",
    Birth_Date: "تاريخ الميلاد",
    Mobile_Number: "رقم الجوال",
    RESET_PASSWORD: "إعادة تعيين كلمة المرور",
    SUBMIT: "يُقدِّم",
    OLD_PASSWORD: "كلمة المرور القديمة",
    PLEASE_ENTER_OLD_PASSWORD: "الرجاء إدخال كلمة المرور القديمة",
    NEW_PASSWORD: "كلمة المرور الجديدة",
    PLEASE_ENTER_NEW_PASSWORD: "الرجاء إدخال كلمة المرور الجديدة",
    PASSWORDS_MUST_MATCH: "يجب أن تتطابق كلمات المرور",
    PLEASE_CONFIRM_PASSWORD: "الرجاء إدخال تأكيد كلمة المرور",
    CONFIRM_PASSWORD: "تأكيد كلمة المرور",
    WE_HAVE_SENT: "لقد أرسلنا كلمة المرور المؤقتة (OTP) عبر الرسائل القصيرة",
    ENTER_OTP: "يدخل OTP",
    SUBMIT_OTP: "يقدم OTP",
    //new setting design text
    SETTINGS: "إعدادات",
    PERSONAL_DATA: "البيانات الشخصية",
    PERSONAL_DATA_DES: "إدارة اسمك ورقم هويتك...إلخ",
    ADDRESS_DETAILS: "تفاصيل العنوان",
    ADDRESS_DETAILS_DES: "إدارة مكان إقامتك",
    MARITAL_STATUS: "الحالة الاجتماعية",
    MARITAL_STATUS_DES: "إدارة حالتك الاجتماعية ورقم المعالين",
    ELIGIBILITY: "الأهلية",
    ELIGIBILITY_DES: "إدارة التوظيف وتفاصيل الدفع الخاصة بك",
    DOCUMENT: "وثيقة",
    DOCUMENT_DES: "عرض كافة المستندات الخاصة بك",
    TERMS_AND_CONDITION: "الشروط والأحكام",
    TERMS_AND_CONDITION_DES: "قم بالاطلاع على شروط وأحكام تمويل",
    FAQ: "التعليمات",
    FAQ_DES: "إدارة حالتك الاجتماعية والمعالين NO.",
    HELP_AND_SUPPORT: "المساعدة والدعم",
    HELP_AND_SUPPORT_DES: "عرض جهات اتصال تمويل",
    ADDRESS_DETAIL: "تفاصيل العنوان",
    SAVE: "يحفظ",
    HIJRI_DOB: "تاريخ الميلاد بالهجرى",
    GEORGIAN_DOB: "تاريخ الميلاد بالميلادى",
    GENERAL_INFO: "معلومات عامة",
    CUSTOMER_DETAIL: "تفاصيل العميل",
    CONTACT_US: "اتصل بنا",
    CONTACT_DES: "24/7 سنجيب على أسئلتك ومشاكلك",
    CONTACT_CARD1: "رقم وحدات المبيعات",
    CONTACT_CARD2: "مركز رعاية العملاء",
    CONTACT_CARD3: "بريد إلكتروني",
    VIEW: "عرض المستند",
    CHANGE_PASSWORD: "تغيير كلمة المرور",
    CHANGE_PASSWORD_DES: "إدارة كلمة المرور الخاصة بك",
    LOADING_DOCUMENT: "تحميل المستند",
    NO_DOCUMENTS_AVAILABLE: "لا توجد مستندات متاحة",
    DOCUMENTS_DRAG_DROP_HEADING: "انقر للتحميل أو اسحب وأفلت",
    DOCUMENTS_DRAG_DROP_TEXT:
      "(يمكن للعميل تحميل المستندات ذات الصلة عند الطلب، ويمكن تحميل الملفات بصيغة PDF و .Jpeg و .PNG فقط. يجب أن يكون الحجم ضمن 3 ميجابايت.)",
    ERROR_FILE_TYPE: "يمكنك تحميل ملفات JPG/PNG/PDF فقط!",
    ERROR_FILE_SIZE_3MB: "يجب أن يكون حجم الملف أقل من 3 ميجابايت!",
    ERROR_FILE_MULTIPLE_EXT:
      "الملفات ذات الامتدادات المتعددة غير مسموح بها. يرجى إعادة تسمية الملف.",
    ERROR_FILE_NAME_CONTRACT: "يجب أن لا يحتوي اسم الملف على كلمة 'عقد'",
    FILE_UPLOAD_SUCCESS: "تم رفع الملف بنجاح",
    FILE_UPLOAD_ERROR: "فشل في رفع الملف.",
    ERROR_NO_FILE_ADDED: "لم يتم إضافة ملف",
  },
  VALIDATION: {
    AGE_REQUIREMENT: "يجب أن تكون على الأقل 18 عامًا",
    CANNOT_BE_EMPTY: "لا يمكن أن يكون فارغًا",
    INCORRECT_LENGTH: " يجب ان تكون الهوية ١٠ ارقام .",
    MUST_BE_CHECKED: "يجب أن يتم التحقق.",
    ID_STARTS_1_OR_2: "يجب أن يبدأ رقم الهوية بـ 1 أو 2.",
    EMAILS_DO_NOT_MATCH: "البريد الإلكتروني لا يتطابق.",
    PASSWORDS_DO_NOT_MATCH: "كلمات المرور لا تتطابق.",
    PASSWORD_REQUIREMENTS: "يجب أن تتكون كلمة المرور من 8 أحرف على الأقل، وتحتوي على حرفين أبجديين؛ أحدهما كبير والآخر صغير، ورقم واحد، وحرف خاص واحد.",
    INVALID_EMAIL_ADDRESS: "عنوان البريد الإلكتروني غير صالح.",
    INVALID_PHONE_NUMBER: "رقم الهاتف غير صالح.",
    PHONE_MUST_START_WITH_966: "يجب أن يبدأ رقم الهاتف بـ 966.",
    FILL_REQUIRED_FIELDS: "يرجى ملء جميع الحقول المطلوبة.",
    IBAN_VAL_FAILED: "فشل التحقق من الـ IBAN. يرجى إدخال الـ IBAN الصحيح.",
    IBAN_VAL_SUCCESS: "تم التحقق من الـ IBAN بنجاح",
  },
  INPUTS: {
    DAY: "يوم",
    MONTH: "شهر",
    YEAR: "سنة",
  },
  MONTHS: {
    JANUARY: "يناير",
    FEBRUARY: "فبراير",
    MARCH: "مارس",
    APRIL: "أبريل",
    MAY: "مايو",
    JUNE: "يونيو",
    JULY: "يوليو",
    AUGUST: "أغسطس",
    SEPTEMBER: "سبتمبر",
    OCTOBER: "أكتوبر",
    NOVEMBER: "نوفمبر",
    DECEMBER: "ديسمبر",
  },
  AND: "و",

  privacy_note: {
    title_1: "اشعار الخصوصية",
    title: "ملاحظة الخصوصية",
    content:
      'تمويل الأولى (المشار إليها فيما يلي بـ "نحن" أو "تمويل الأولى" أو "المؤسسة" تحترم حقك في خصوصية البيانات. في هذا الإشعار، تشير كلمة "أنت" إلى صاحب البيانات الذي تتم معالجة بياناته الشخصية بواسطة تمويل الأولى.\n' +
      "يوفر إشعار الخصوصية هذا معلومات حول كيفية تعامل شركة تمويل الأولى مع المعلومات الشخصية الخاصة بك ويصف الحقوق التي قد تكون لديك فيما يتعلق بمعلوماتك الشخصية. ينطبق هذا الإشعار على شركة تمويل الأولى وجمعها للمعلومات الشخصية واستخدامها والكشف عنها عبر الإنترنت وغيره.\n" +
      "تلتزم شركة تمويل الأولى بالحفاظ على سرية وخصوصية بيانات ومعلومات المستخدم.\n" +
      "لا يجوز لشركة تمويل الأولى جمع أو معالجة أو الكشف عن أي بيانات أو معلومات شخصية إلا وفقًا للضوابط المحددة المنصوص عليها في التعليمات التي تحكم سرية المعلومات الصادرة عن الجهات التنظيمية في المملكة مثل نظام قانون حماية البيانات الشخصية PDPL و المكتب الوطني لإدارة البيانات NDMO، والبنك المركزي السعودي  SAMA بما في ذلك جميع التعديلات المطبقة عليها من وقت لآخر.\n",
  },
  personal_data_collection_processing_disclosures: {
    title: "جمع ومعالجة وكشف البيانات الشخصية",
    collection: {
      title: "متى تقوم تمويل الأولى بجمع المعلومات الشخصية عنك",
      content:
        "يتم جمع هذه البيانات عندما تستخدم خدماتنا من خلال القنوات عبر الإنترنت وغيره",
    },
    types: {
      title:
        " ما هي أنواع المعلومات الشخصية التي تجمعها تمويل الأولى وتحتفظ بها",
      content_1:
        "عندما تتعامل مع تمويل الأولى، قد نقوم بجمع بيانات للمساعدة في التعرف عليك والاتصال بك، بما في ذلك، على سبيل المثال لا الحصر، اسمك وعنوان بريدك الإلكتروني وعنوانك الفعلي ورقم هاتفك (الخط الأرضي و/أو المحمول) ورقم الهوية.",
      content_2:
        "إذا قمت بإنشاء حساب، فقد نقوم بجمع اسم المستخدم وكلمة المرور وتاريخ الميلاد ومعلومات الهوية الوطنية لتزويدك بخدماتنا.\nإذا قمت بإنشاء حساب، فقد نقوم بجمع اسم المستخدم وكلمة المرور وتاريخ الميلاد ومعلومات الهوية الوطنية لتزويدك بخدماتنا.",
      content_3:
        "قد نقوم أيضًا بجمع بيانات حول الجهاز الذي تستخدمه للوصول إلى خدماتنا عبر الإنترنت. يتضمن ذلك معرف الجهاز ومعرف الإعلان وتفاصيل المتصفح أثناء استخدام خدماتنا عبر الإنترنت.",
      content_4:
        "\tقد نقوم بجمع معرف الجهاز IP الخاص بك والبيانات المتعلقة بعنوان IP هذا، مثل البيانات الجغرافية و بيانات النطاق.",
      content_5:
        "قد نقوم بجمع أنواع مختلفة من البيانات الشخصية عنك من مصادر مختلفة. فيما يلي الفئات الإضافية من البيانات الشخصية التي قد نكون جمعناها من خلال مصادر مختلفة",
      content_6:
        "\tقد نقوم بجمع معلوماتك المالية بما في ذلك البيانات المالية وتفاصيل الحساب المصرفي والتاريخ الائتماني وتاريخ/تفاصيل القروض ومعلومات الراتب.",
    },
  },
  personal_information_collection: {
    title: "المعلومات الشخصية التي نجمعها و ممن  نجمعها",
    what_we_collect: {
      title: " ما الذي قد نجمعه",
      content_1:
        " معلومات الهوية (الاسم بما في ذلك الاسم الأول و الأخير وتاريخ الميلاد ورقم الهوية الوطنية والحالة الاجتماعية)",
      content_2: "المعلومات الديموغرافية: العمر، الجنس.",
      content_3:
        "معلومات الاتصال: العنوان الوطني، عنوان البريد الإلكتروني، رقم (أرقام) الهاتف.",
      content_4:
        " معلومات الشركة (الاسم والعنوان والموقع ونوع الأصول المباعة ورقم السجل التجاري وأرقام الهواتف وعناوين البريد الإلكتروني والمواقع الإلكترونية والبيانات المالية والدخل والقيمة السوقية للأرض).",
      content_5: "بيانات ذات صلة بملفات تعريف الارتباط.",
      content_6:
        "  التسجيل الصوتي والإلكتروني، على سبيل المثال، عند الاتصال بخدمة العملاء لطرح سؤال.",
      content_7:
        "التفاصيل المالية (تفاصيل الحساب البنكي، البيانات المالية، الدخل، التاريخ الائتماني، بيانات طلب القرض أو الائتمان، معلومات الراتب)",
      content_8: " تسجيل الفيديو لأغراض تقديم الخدمة.",
    },
    from_whom: {
      title: "ممن نجمعها",
      content_1: "المعلومات التي تقدمها.",
      content_2:
        "معلوماتك من المنظمات الأعضاء (البنوك، منظمات الإقراض، مقدمي التأمين، شركات الاتصالات)، ومن الشركات الخاصة ذات الملكية الوطنية مثل علم.",
    },
    purpose: {
      title: "نقوم بجمع معلوماتك الشخصية لأغراض مختلفة كما هو مذكور أدناه:",
      content_1: "لأغراض إعداد العملاء / أغراض تسجيل العملاء.",
      content_2: "للتحقق من هويتك.",
      content_3: "لمعالجة طلب التمويل أو التأمين.",
      content_4: "لمنع الاحتيال والكشف غير المصرح به عن معلوماتك الشخصية.",
      content_5:
        "لتسجيل وإظهار كيفية قيامنا بإجراء عملية حل النزاعات والشكاوى والتوصل إلى حلول.",
      content_6:
        "للامتثال للمتطلبات التجارية والقانونية والتنظيمية المفروضة على تمويل الأولى.",
      content_7:
        "لتطوير المنتجات والبحث، ولأي غرض يخضع للقيود المنصوص عليها في هذا الإشعار والقوانين المعمول بها المفروضة على تمويل الأولى.",
      content_8:
        "لتلبية طلباتك، والمعاملات والاتصالات الأخرى حول مواقعنا الإلكترونية وخدماتنا عبر الإنترنت.",
      content_9:
        "قد يتم استخدام بياناتك الشخصية باستثناء البيانات الحساسة لأغراض التسويق.",
      content_10: " قد يتم استخدام بياناتك الشخصية لاتخاذ القرارات تلقائيًا.",
    },
  },
  data_retention: {
    title: "ما هي مدة احتفاظ تمويل الأولى بالبيانات الشخصية؟",
    content:
      "تحتفظ تمويل الأولى ببياناتك بحسب المدة المحددة في نظام قانون حماية البيانات أو طالما أننا بحاجة إليها لأغراض قانونية وأيضًا للأغراض التنظيمية وفقًا لتعليمات السلطة التنظيمية, مثل مؤسسة النقد العربي السعودي. <br> تقوم تمويل الأولى بمراجعة البيانات التي نحتفظ بها بشكل دوري ونقوم بإخفاء هوية أصحابها أو حذفها بشكل آمن عندما لا تكون هناك حاجة قانونية أو تنظيمية للاحتفاظ به.",
  },
  data_sharing: {
    title: "مع من تشارك تمويل الأولى معلوماتك الشخصية؟",
    content:
      "تشارك تمويل الأولى بياناتك الشخصية مع مختلف المنظمات بما في ذلك برامج التحقق من الهوية، وشركات التحقيق المالي، والبنوك، ومقدمي خدمات السجل الائتماني، ومقدمي الخدمات السحابية الموثوقين، والسلطات التنظيمية في المملكة العربية السعودية الذين توافق على الكشف عن بياناتك الشخصية لهم. قبل مشاركة البيانات الشخصية مع هذه المنظمات الشريكة، نقوم بمراجعة الخدمات التي تقدمها هذه المنظمات ونطلب منها الحفاظ على سرية وأمان البيانات الشخصية وعدم استخدامها لأي غرض باستثناء أداء الخدمات المتفق عليها.\n" +
      "الإفصاح لأسباب قانونية: قد نشارك البيانات الشخصية مع أطراف ثالثة للامتثال للمتطلبات القانونية الصحيحة مثل القانون السعودي أو اللوائح أو أوامر التفتيش أو مذكرات الاستدعاء أو أوامر المحكمة أو الإجراءات القانونية الأخرى.\n",
  },
  minors_privacy: {
    title: "خصوصية القاصرين",
    content:
      "تهتم تمويل الأولى بحماية خصوصية القاصرين. موقع الويب غير موجه للأفراد الذين تقل أعمارهم عن السن القانونية، ونحن لا نجمع معلومات شخصية عن عمد من هؤلاء الأفراد.",
  },
  changes_notice: {
    title: "هل سنبلغك بالتغييرات التي تطرأ على إشعار الخصوصية هذا؟",
    content:
      "إذا قمنا بتغيير إشعار الخصوصية هذا، فسنخبرك بالتغييرات عن طريق نشر الإصدار المحدث على جميع قنوات الاتصال المعمول بها. تلتزم شركة تمويل الأولى بحماية واحترام خصوصيتك.",
  },
  data_subject_choices: {
    title: "الحقوق المتاحة لأصحاب البيانات الشخصية",
    title_content:
      "بموجب قانون حماية البيانات الشخصية في المملكة العربية السعودية، يحق لأصحاب البيانات الشخصية التمتع بالحقوق التالية. ومع ذلك، سيتم صرف الحقوق المتعلقة بصاحب البيانات وفقًا للالتزامات التنظيمية والقانونية المترتبة على تمويل الأولى.",
    choice_1:
      "الحق في طلب معلومات حول أنشطة المعالجة التي تتم على بياناتهم الشخصية.",
    choice_2: "الحق في طلب الوصول إلى بياناتهم الشخصية.",
    choice_3: "الحق في طلب الحصول علي بياناتهم الشخصية.",
    choice_4: "الحق في طلب مسح البيانات الشخصية في حالات محددة.",
    choice_5: "الحق في سحب الموافقة في حالات محددة.",
    choice_6: "الحق في طلب تصحيح أو تحديث أو استكمال بياناتهم الشخصية.",
    content:
      'لأية استفسارات أو شكاوى، يمكنك إرسال بريد إلكتروني إلى " DPO@tamweel-aloula.com \n' +
      '" أو استخدام ميزة تواصل معنا المتوفرة على موقعنا.\n',
  },
  data_access_correction: {
    title: "طرق الوصول إلى البيانات الشخصية أو تصحيحها أو تعديلها",
    content:
      "إذا كنت تعتقد أن أي معلومات واردة في تقرير الائتمان الشخصي الخاص بك غير دقيقة أو غير كاملة، فيمكنك رفع طلب وإخبارنا على وجه التحديد عن سبب اعتقادك بأنها غير دقيقة أو غير كاملة.\n" +
      'يمكنك التواصل معنا للاستفسار على " DPO@tamweel-aloula.com" أو استخدام ميزة تواصل معنا المتوفرة على موقعنا.\n',
  },
  UPLOAD_DOCUMENT: "ارسال مستند",
  APPLY: "تقديم",
  TERMS_AND_CONDITIONS: "الشروط و الاحكام",
  CLOSE: "إغلاق",
  STEP_OFFER: "عرض",
  SUBMIT: "إرسال",
  STEP_CONTRACT: "العقد",
  DISBURSEMENNT: "صرف",
  STEP_DONE: "تم",
  QARAR_COMMENTS: "ملاحظات قرار",
  SHARED: {
    SEARCH: "بحث",
    ONE: "١",
    TWO: "٢",
    THREE: "٣",
    FOUR: "٤",
  },
  PROVIDERS: {
    PROVIDERS: "مزود",
    SUBMIT_APPL_SUCEESS: "تم تقديم الطلب بنجاح.",
    SUBMIT_APPL_ERROR: "فشل. يرجى المحاولة مرة أخرى.",
    NO_DATA_FOUND: "لم يتم العثور على بيانات.",
  },
  VOUCHERS: {
    VOUCHERS: "قسائم",
    SHERIZERO_PT1: "٪معدل ربح ٠",
    SHERIZERO_PT2: "يوفر الوصول إلى أكثر من",
    SHERIZERO_PT4: "مدة تبدأ من ٤ إلى ١٢ شهرا.",
    FIVE_THOUSAND: "٥،٠٠٠",
    STARTS_FROM: "يبدأ من",
    APPLY_NOW: "قدم الأن",
    COMING_SOON: "قريبا",
    EIGHTY_FIVE_MERCHANTS: "٨٥ متجر",
    FOUR_HUNDRED_MERCHANTS: "٤٠٠ متجر",
    SHERI_PT1: 'معدل النسبة السنوية تبدأ من ١٥٫٠٨٪',
    SHERI_PT2: 'مدة تبدأ من ٦ الى ٦٠ شهر',
    MAX_LIMIT: "حد اعلى يصل الى",
    FIVE_HUNDRED_THOUSAND: "٥٠٠،٠٠٠",
    FILL_FORM: "يرجى تعبئة النموذج التالي",
  },
  MERCHANTS: {
    BEST_SELLERS: 'الأكثر مبيعاً',
    PROVIDERS: 'البطاقات',
    ALL_CARDS: 'جميع البطاقات',
    SEARCH_BY_NAME: 'ابحث باسم البطاقة'
  },
  PRE: {
    WELCOME: "مرحباً بك في تمويل!",
    DESCRIPTION: "اتبع هذه الخطوات لإكمال إعداد الملف الشخصي:",
    STARTED: "اتبع هذه الخطوات لإكمال إعداد الملف الشخصي:",
    PERSONAL_DATA_HEADING: "بياناتك الشخصية",
    PERSONAL_DATA_DESCRIPTION: "قم بإدارة اسمك ورقم الهوية... إلخ:",
    ADDRESS_DTL_HEADING: "تفاصيل العنوان",
    ADDRESS_DTL_DESCRIPTION: "قم بإدارة مكان إقامتك",
    MARITAL_STATUS_HEADING: "الحالة الاجتماعية",
    MARITAL_STATUS_DESCRIPTION: "قم بإدارة حالتك الاجتماعية وعدد المُعالين",
    ELIGIBILITY_HEADING: "الأهلية",
    ELIGIBILITY_DESCRIPTION: "قم بإدارة تفاصيل عملك وطريقة الدفع",
  },
};

export default locale;
